export default __webpack_public_path__ + "static/media/banque.8e5a7641.png";